import axios from "axios";
import AuthService from "./authService";
const BASE_URL = process.env.REACT_APP_BACKEND_URL;

const LOGGER_BASE_ROUTE = "/api/v1/logger";

class SlackService {
  static async flagMissingKey(missingKey: string) {
    try {
      await axios.post(
        `${BASE_URL}${LOGGER_BASE_ROUTE}/missing-key`,
        {
          missingKey,
        },
        AuthService.getAuthHeader()
      );
    } catch (error) {
      console.error(error);
    }
  }
}

export default SlackService;
